export const limitOffsetToPage = ({ limit, offset }: { limit: number; offset: number }) => {
  // If limit is less than 1, our query is invalid and would result in division by 0
  if (limit < 1) return 1

  const pageSize = limit

  // Note that if offset % limit !== 0, we won't end up with a perfect mapping
  // Example:
  //   limit = 10
  //   offset = 25
  //   page = (25 / 10) => 2.5
  //   page = (2 + 1) = 3
  // But on the backend, page 3 would likely return records 20 - 30, rather than 25 - 35.
  const pageNumber = Math.floor(offset / pageSize) + 1

  return pageNumber
}
